import { render, staticRenderFns } from "./StatusScreen.vue?vue&type=template&id=516b81d0&scoped=true"
import script from "./StatusScreen.vue?vue&type=script&lang=js"
export * from "./StatusScreen.vue?vue&type=script&lang=js"
import style0 from "./StatusScreen.vue?vue&type=style&index=0&id=516b81d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b81d0",
  null
  
)

export default component.exports